import { render, staticRenderFns } from "./BuildPeopleFilterModal.vue?vue&type=template&id=edae312a&scoped=true&"
import script from "./BuildPeopleFilterModal.vue?vue&type=script&lang=js&"
export * from "./BuildPeopleFilterModal.vue?vue&type=script&lang=js&"
import style0 from "./BuildPeopleFilterModal.vue?vue&type=style&index=0&id=edae312a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edae312a",
  null
  
)

export default component.exports